// @flow

import React, { useState } from 'react';
import { MapSearchContext } from '../MapSearchContainer';
import { objectOf, string } from 'prop-types';

const SearchInput = ({ translations }) => {
  const [data, setData] = useState({ text: '', timeout: 0 });

  const updateSearchableText = ({
    value,
    setFilters,
  }: {
    value: string,
    setFilter: any,
  }): void => {
    if (data.timeout) {
      clearInterval(data.timeout);
    }
    const timeout = setTimeout(() => {
      setFilters({ name: 'SearchableText', value });
    }, 1000);
    setData({ text: value, timeout });
  };
  return (
    <div className="filter">
      <MapSearchContext.Consumer>
        {({ setFilters }) => {
          return (
            <div className="input-cont">
              <input
                type="text"
                value={data.text}
                placeholder={
                  translations ? translations['search_placeholder'] : 'Cerca'
                }
                onChange={e =>
                  updateSearchableText({ value: e.target.value, setFilters })
                }
              />
            </div>
          );
        }}
      </MapSearchContext.Consumer>
    </div>
  );
};

SearchInput.propTypes = {
  translations: objectOf(string),
};

export default SearchInput;
